module.exports = __webpack_public_path__ + "static/img/training.cd6c7d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training.png
// module id = uiGE
// module chunks = 1